import React from "react";
import { Control, FieldPathByValue, FieldValues, useController } from "react-hook-form";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TextField, TextFieldProps } from "@mui/material";
import { texFieldDefaultColumnProps, textFieldDefaultProps } from "./TextFieldDefaultProps";
import { MdmFormProps } from "./MdmFormProps";
import { kendoDefaultDateFormatddMMyyyy } from "../Utils/dates";

type TextFieldInputProps = {
  direction?: "row" | "column";
};

export const RHFDatePicker = <
  TFieldValues extends FieldValues,
  TPath extends FieldPathByValue<TFieldValues, Date | null | undefined>
>({
  control,
  name,
  label,
  direction = "row",
  required,
}: {
  control: Control<TFieldValues>;
  name: TPath;
} & MdmFormProps &
  TextFieldProps &
  TextFieldInputProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        {...field}
        label={label || name}
        inputFormat={kendoDefaultDateFormatddMMyyyy}
        renderInput={(params) => (
          <TextField
            {...params}
            {...textFieldDefaultProps}
            {...(direction === "row" ? textFieldDefaultProps : texFieldDefaultColumnProps)}
            error={!!error}
            helperText={error?.message}
            required={required}
          />
        )}
      />
    </LocalizationProvider>
  );
};
